import {Injectable} from '@angular/core';
import {BorrowedInfoService} from '../service/borrowed-info.service';
import {BorrowedInfo} from '../model/borrowed-info.model';

@Injectable()
export class BorrowedInfoInteractor {
    constructor(private readonly borrowedInfoService: BorrowedInfoService) {
    }

    public async createOrUpdateBorrowedInfo(borrowedInfo: BorrowedInfo): Promise<BorrowedInfo> {
        if (!borrowedInfo.id) {
            return await this.borrowedInfoService.create(borrowedInfo);
        } else {
            await this.borrowedInfoService.update(borrowedInfo);
            return await this.borrowedInfoService.getByLoanApplicationId(borrowedInfo.loanApplicationId);
        }
    }

    public async getByLoanApplicationId(id: string): Promise<BorrowedInfo> {
        return await this.borrowedInfoService.getByLoanApplicationId(id);
    }

    public async delete(id: string): Promise<BorrowedInfo> {
        return await this.borrowedInfoService.delete(id);
    }
}
